import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import SurveyCrad from './surveyCrad';
import { getDaybyDate, isSuperAndSubAdmin } from '../../../utils/helper';
import DonutChartCard from '../../../component/common/cards/DonutChartCard';
import moment from 'moment/moment';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const ProgressBar = ({ label, percentage }) => (
  <div className="mb-4">
    {!!label && (
      <div className="flex justify-between items-center mb-1">
        <span className="text-lg font-normal">{label}</span>
        <span className="text-sm text-green-600">{percentage}%</span>
      </div>
    )}
    <div className="w-full bg-[#C2EC97] rounded-full h-2 flex items-center">
      <div
        className="bg-[#67A14A] h-2.5 rounded-full"
        style={{ width: `${percentage}%`, height: '133%' }}
      ></div>
    </div>
  </div>
);

const data = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June'],
  datasets: [
    {
      label: pulseSurveyPageData.surveyMonthlyAnalysisText,
      data: [2, 9, 8, 2, 6, 7],
      backgroundColor: '#4A57DA',
      borderColor: '#4A57DA',
      borderRadius: 3,
      borderWidth: 1
    }
  ]
};

const options2 = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false
      }
    },
    y: {
      grid: {
        drawOnChartArea: false
      }
    }
  }
};

const B2BAdminDashboardInsight = ({ resultData }) => {
  const isAdmin = isSuperAndSubAdmin();
  const [Id, setId] = useState('');

  const dataD = resultData?.weeklyUserCounts && {
    labels: resultData.weeklyUserCounts
      ? resultData?.weeklyUserCounts.map((item) => getDaybyDate(item.date))
      : [],
    datasets: [
      {
        label: pulseSurveyPageData.weeklyUsageText,
        data: resultData?.weeklyUserCounts.map((item) => item.count),
        backgroundColor: '#4A57DA',
        borderColor: '#4A57DA',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  console.log("Jai", resultData);

  const OverAllResponseData = [
    {
      label: pulseSurveyPageData.overAllResponsesData.responseText,
      value:
        resultData?.completedSurveys + resultData?.openSurveys
          ? resultData?.completedSurveys + resultData?.openSurveys
          : 0,
      percentage:
        resultData?.completedSurveys + resultData?.openSurveys === 'NaN'
          ? 0
          : resultData?.completedSurveys + resultData?.openSurveys || 0,
      color: '#F05289'
    },
    {
      label: pulseSurveyPageData.overAllResponsesData.noResponseText,
      value: resultData?.notAttemptedSurveys ? resultData?.notAttemptedSurveys : 0,
      percentage:
        resultData?.notAttemptedSurveys === 'NaN' ? 0 : resultData?.notAttemptedSurveys || 0,
      color: '#FF9BCB'
    }
  ];

  const handleQuestionAction = (id) => {
    if (Id === '') {
      setId(id);
    } else {
      setId('');
    }
  };
  return (
    <div>
      <div className="flex flex-col lg:flex-row md:flex-col gap-5 sm:w-full mb-5 w-full overflow-x-auto horizontal-card-scrollbar">
        <div className="w-full lg:max-w-[286px] 2xl:max-w-[320px]">
          <DonutChartCard
            data={OverAllResponseData}
            title={pulseSurveyPageData.overAllResponsesData.title}
            hidePercentage
            labelClassName={'w-full'}
            className={
              'dark:!bg-shoorah-darkBgTabColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
        <div className="flex flex-col justify-between gap-5 w-full sm:min-w-[333px]">
          <div className="px-5 md:py-6 py-5 bg-[#ffffff] border border-shoorah-borderGray dark:bg-shoorah-darkBgTabColor min-h-[175px] dark:text-shoorah-darkBg dark:border-none rounded-xl">
            <div className="text-xl font-medium leading-[22px] text-shoorah-lightBlack mb-[22px] dark:text-shoorah-darkBg">
              {pulseSurveyPageData.averageCompetitionTimeText}
            </div>
            <div className="text-[48px] leading-[36px] font-semibold text-shoorah-lightBlack mb-[18px] dark:text-shoorah-darkBg">
              0 <span className="text-[30px] leading-[36px] font-semibold italic">{pulseSurveyPageData.minutesText}</span>
            </div>
            <div className="flex items-center justify-between w-full">
              <div className="text-xs leading-5 text-[#8FD460]">+0%</div>
              <div className="text-[rgba(41,45,50,0.38)] text-xs leading-5">{pulseSurveyPageData.last7DaysText}</div>
            </div>
          </div>
          <div className="px-5 md:py-6 py-5 bg-[#ffffff] border border-shoorah-borderGray rounded-xl dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[30px]">
              <div className="text-xl leading-[22px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pulseSurveyPageData.completionRateText}
              </div>
              <div className="text-[18px] leading-[21px] font-medium text-[#67A14A]">
                {resultData?.completionRate || 71.5} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 71.5} />
            </div>
          </div>
        </div>
        <div className="lg:w-2/5 w-full sm:min-w-[450px] overflow-x-auto horizontal-card-scrollbar">
          <div className="px-5 md:py-4 py-5 bg-[#FFFFFF] rounded-xl border border-shoorah-borderGray h-full dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className=" text-[20px] lg:text-[20px] md:text-[25px] leading-tight font-medium w-[80%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg mb-[25px]">
              {pulseSurveyPageData.topPerformingTemplateText}
            </div>
            {resultData && resultData?.topPerformingTemplate?.length > 0 ? (
              <>
                {resultData?.topPerformingTemplate?.map((item, index) => (
                  <SurveyCrad
                    item={item}
                    key={index}
                    handleQuestionAction={(id) => handleQuestionAction(id)}
                    Id={Id}
                    setId={setId}
                    handleDeletePulseSurve={(deleteId) => console.log('deleteId', deleteId)}
                    isAdmin={isAdmin}
                  />
                ))}
              </>
            ) : (
              <p>{pulseSurveyPageData.noPerformingTemplateText}</p>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row md:flex-col gap-5 sm:w-full lg:mb-2 overflow-x-auto horizontal-card-scrollbar overflow-y-hidden">
        <div className="flex flex-col justify-between w-full md:w-full lg:min-w-[235px] lg:max-w-[265px] 2xl:max-w-[300px] h-[200px] md:h-[200px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <p className="text-[20px] lg:text-[20px] md:text-[25px] leading-tight h-[66px]  font-medium  w-[80%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {pulseSurveyPageData.percentageOfIncompleteAssessmentText}
          </p>
          <p className="lg:text-[48px] text-[36px] text-shoorah-lightBlack font-medium dark:text-shoorah-darkBg">
            {resultData?.incompletePercentage ? resultData?.incompletePercentage : '0'} %
          </p>
        </div>

        <div className=" flex flex-col justify-between w-full md:w-full lg:min-w-[235px] lg:max-w-[405px] 3xl:min-w-[420px] h-[300px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <p className="text-[20px] lg:text-[20px] md:text-[25px] leading-tight h-[66px]  font-medium  w-[100%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {pulseSurveyPageData.dropOffPointText}
          </p>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pulseSurveyPageData.introText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 7} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 7} />
            </div>
          </div>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pulseSurveyPageData.incompleteText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 55} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 55} />
            </div>
          </div>

          <div className=" md:py-2 py-1.5 bg-[#ffffff]  dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex items-center justify-between mb-[10px]">
              <div className="text-base font-medium leading-[22px] text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {pulseSurveyPageData.completedText}
              </div>
              <div className="text-xs leading-[100%] font-medium text-[#67A14A]">
                {resultData?.completionRate || 89} %
              </div>
            </div>
            <div>
              <ProgressBar percentage={resultData?.completionRate?.split('%')[0] || 89} />
            </div>
          </div>
        </div>


        <div className="h-[344px] max-w-[564px] w-full bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
          <div className="flex justify-between w-full items-center mb-1">
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {pulseSurveyPageData.weeklyUsageText}
            </p>
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {resultData?.totalWeeklyUsers || 456} {pulseSurveyPageData.usersText}
            </p>
          </div>
          <div className="flex justify-between w-full items-center mb-[18px]">
            <p className="text-[14px] leading-5 text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {moment(resultData?.weeklyUserCounts?.[0]?.date)?.format('Do')} -{' '}
              {moment(
                resultData?.weeklyUserCounts?.[resultData?.weeklyUserCounts?.length - 1]?.date
              )?.format('Do MMM, YYYY')}
            </p>
            <p className="text-[16px] font-medium leading-6 text-[#28D9A0] flex flex-row items-center">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9075 10C11.0899 10 11.2868 9.92565 11.3225 9.73992C11.3544 9.57417 11.3113 9.39471 11.1932 9.26602L8.33607 6.15201C8.1501 5.94933 7.8486 5.94933 7.66263 6.15201L4.80549 9.26602C4.68741 9.39471 4.64431 9.57417 4.67617 9.73992C4.71187 9.92565 4.90875 10 5.0912 10L10.9075 10Z" fill="#61CD82" />
              </svg>
              {data?.will_come_soon || +235.21} %
            </p>
          </div>
          <Bar
            data={dataD || data}
            options={{
              ...options2
            }}
            className="!h-[222px]"
          />
        </div>
      </div>
    </div>
  );
};

export default B2BAdminDashboardInsight;
